import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-shared-fields-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './shared-fields-banner.component.html',
  styleUrls: ['./shared-fields-banner.component.scss'],
})
export class SharedFieldsBannerComponent {
  expanded = false;

  sections = [
    {
      label: 'Anagrafica',
      fields:
        'Nome, Cognome, Email, Cellulare, Indirizzo, Città, Zona, CAP, Età, Data di Nascita, Codice Fiscale, IBAN',
    },
    {
      label: 'Formazione',
      fields: 'Titolo di studio, Inglese, Italiano, Spagnolo',
    },
    {
      label: 'Disponibilità',
      fields: 'Giorni, Orari, Tipo incarico, Patente, Auto, Fumatrice',
    },
  ];

  toggle(): void {
    this.expanded = !this.expanded;
  }
}
